
import { gql } from 'react-apollo';

import {
  GET_HOST_FAQS_START,
  GET_HOST_FAQS_SUCCESS,
  GET_HOST_FAQS_ERROR
} from '../constants';

const query = gql`
  query {
  getHostListingWebsiteFaq {
    status
    errorMessage
    dataList {
      id
      question
      answer
      type
      hostId
      listingId
    }
     faqDescription {
      id
      name
      value
    }
  }
}
`;

export function getHostFaqs(id) {

  return async (dispatch, getState, { client }) => {
    dispatch({
      type: GET_HOST_FAQS_START,
    });
    try {
      // Send Request to get listing data
      const { data } = await client.query({
        query,
        fetchPolicy: 'network-only'
      });
      if (data && data.getHostListingWebsiteFaq.dataList) {
        dispatch({
          type: GET_HOST_FAQS_SUCCESS,
         dataList: data?.getHostListingWebsiteFaq?.dataList,
         faqDescription: data?.getHostListingWebsiteFaq?.faqDescription
        });
      } else {
        dispatch({
          type: GET_HOST_FAQS_ERROR,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_HOST_FAQS_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}
